import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { createStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core';
import BaseTypography from '../Text/BaseTypography';

interface NotificationBadgeStyleProps {
  isSidebar: boolean;
  isPreview: boolean;
}
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      width: ({ isPreview }: NotificationBadgeStyleProps) =>
        isPreview ? '12px' : '18px',
      height: ({ isPreview }: NotificationBadgeStyleProps) =>
        isPreview ? '12px' : '18px',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: ({ isSidebar }: NotificationBadgeStyleProps) =>
        isSidebar
          ? theme.palette.primary.contrastText
          : theme.palette.primary.main,
      color: ({ isSidebar }: NotificationBadgeStyleProps) =>
        isSidebar
          ? `${theme.palette.primary.main}`
          : `${theme.palette.primary.contrastText}`,
      '&:hover': {
        color: ({ isSidebar }: NotificationBadgeStyleProps) =>
          isSidebar
            ? `${theme.palette.primary.main}`
            : `${theme.palette.primary.contrastText}`,
      },
    },
    oval: {
      borderRadius: '50%',
    },
    rectangle: {
      borderRadius: '2px',
      lineHeight: '19px',
      padding: 0,
    },
    hidden: {
      opacity: 0,
    },
  }),
);

interface NotificationBadgeProps {
  content: number;
  isSidebar?: boolean;
  showZero?: boolean;
  isPreview?: boolean;
  htmlId?: string;
}

export const NotificationBadge: React.FC<NotificationBadgeProps> = React.memo(
  ({
    content,
    isSidebar = false,
    showZero = false,
    isPreview = false,
    htmlId,
  }) => {
    const classes = useStyles({ isSidebar, isPreview });

    return (
      <span
        data-testid={htmlId}
        className={`${classes.root} ${
          isSidebar ? classes.oval : classes.rectangle
        } ${content < 1 && !showZero ? classes.hidden : ''}`}
      >
        {!isPreview ? (
          <BaseTypography fontType="9Regular" component="span">
            {content}
          </BaseTypography>
        ) : (
          <BaseTypography
            fontType="9Regular"
            style={{ fontSize: 6 }}
            component="span"
          >
            {content}
          </BaseTypography>
        )}
      </span>
    );
  },
);
